/** Мок только при явном `VITE_USE_MOCK=true` (JSON и in-memory, ТЗ §2). */
export const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true'

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? ''
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

/** Ключ Яндекс.Карт JS API (геокодер, карты). Передаётся через VITE_YANDEX_MAPS_API_KEY. */
export const YANDEX_MAPS_API_KEY = import.meta.env.VITE_YANDEX_MAPS_API_KEY ?? ''

/**
 * Отдельный ключ Geosuggest API (Yandex). Если задан — JS API 2.1
 * подгружается с `&suggest_apikey=...`, и `ymaps.suggest()` становится
 * доступен (быстрее, чем `ymaps.geocode`). Если не задан — саджест
 * автоматически идёт через `ymaps.geocode` (см. `useAddressSuggest`).
 *
 * Получить ключ: https://yandex.com/dev/geosuggest (отдельный сервис в
 * developer-кабинете, не путать с JS API / HTTP-Геокодером).
 */
export const YANDEX_SUGGEST_API_KEY =
  import.meta.env.VITE_YANDEX_SUGGEST_API_KEY ?? ''
